@let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
<div
  class="audio-settings-container"
  [ngClass]="{ 'audio-settings-container-overflow': displayedInPopupWindow }">
  <div class="audio-header">
    <button
      class="rescan-button"
      (click)="scanDevices()"
      appBrandingColor
      [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
      styleType="color"
      [matTooltip]="'AUDIO.RESCAN_DEVICES_TOOLTIP' | translate"
      [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
      {{ 'AUDIO.RESCAN_DEVICES' | translate }}
    </button>
  </div>
  <form
    [formGroup]="audioForm"
    class="text-left">
    <div class="title-audio-setting">{{ 'AUDIO.NOTIFICATIONS_AND_RINGING' | translate }}</div>
    <div class="volume-settings">
      <div class="volume-setting-div">
        <mat-label class="label-style">{{ 'AUDIO.NOTIFICATION_SOUND_VOLUME' | translate }}</mat-label>
        @if (showSliders) {
          <mat-slider
            class="volume-slider"
            [max]="100"
            [min]="0"
            (change)="onChange('Notification')"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
            <input
              matSliderThumb
              formControlName="notificationSoundVolume" />
          </mat-slider>
        }
      </div>
      <div class="volume-setting-div add-padding">
        <mat-label class="label-style">{{ 'AUDIO.RINGING_SOUND_VOLUME' | translate }}</mat-label>
        @if (showSliders) {
          <mat-slider
            class="volume-slider"
            [max]="100"
            [min]="0"
            (change)="onChange('Call')"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
            <input
              matSliderThumb
              formControlName="ringingSoundVolume" />
          </mat-slider>
        }
      </div>
      <mat-form-field
        appearance="outline"
        class="speaker-dropdown density-minus-3">
        <mat-label>{{ 'AUDIO.RINGING_&_NOTIFICATION_SPEAKER' | translate }}</mat-label>
        @if (!displayedInPopupWindow) {
          <mat-select
            formControlName="notificationSpeakerDevice"
            (selectionChange)="disabled = false"
            class="device-list density-minus-3">
            @for (device of settingsService.outputDevices$ | async; track device.deviceId) {
              <mat-option [value]="device.deviceId">{{ device.label }}</mat-option>
            }
          </mat-select>
        } @else {
          <select
            (change)="disabled = false"
            formControlName="notificationSpeakerDevice"
            matNativeControl
            required>
            @for (device of settingsService.outputDevices$ | async; track device.deviceId) {
              <option [ngValue]="device.deviceId">
                {{ device.label }}
              </option>
            }
          </select>
        }
      </mat-form-field>
      <ng-template
        [ngTemplateOutlet]="testSound"
        [ngTemplateOutletContext]="{ $implicit: notificationSpeakerDevice, type: 'Notification' }"></ng-template>
      <!--      TODO: remove *ngIf="false" when we return to the quietRinging option-->
      @if (false) {
        <mat-checkbox
          formControlName="quietRinging"
          color="primary"
          >{{ 'AUDIO.QUIET_RINGING_WHEN_IN_MEETING' | translate }}
        </mat-checkbox>
      }
      <div class="ring-calls">
        <mat-label
          class="label-style"
          matTooltip="{{ 'AUDIO.ALSO_RING_CALLS_&_MEETINGS_SPEAKER_TOOLTIP' | translate }}"
          >{{ 'AUDIO.ALSO_RING_CALLS_&_MEETINGS_SPEAKER' | translate }}</mat-label
        >
        <mat-slide-toggle
          formControlName="enableDualRinging"
          (change)="disabled = false"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
      </div>
    </div>
    <div class="title-audio-setting">{{ 'AUDIO.CALLS_&_MEETINGS' | translate }}</div>
    <div class="speaker-settings">
      <div class="output-settings">
        <mat-form-field
          appearance="outline"
          class="speaker-dropdown density-minus-3">
          <mat-label>{{ 'AUDIO.CALLS_AND_MEETINGS_SPEAKER' | translate }}</mat-label>
          @if (!displayedInPopupWindow) {
            <mat-select
              formControlName="speakerDevice"
              (selectionChange)="disabled = false"
              class="device-list density-minus-3">
              @for (device of settingsService.outputDevices$ | async; track device.deviceId) {
                <mat-option [value]="device.deviceId">
                  {{ device.label }}
                </mat-option>
              }
            </mat-select>
          } @else {
            <select
              (change)="disabled = false"
              formControlName="speakerDevice"
              matNativeControl
              required>
              @for (device of settingsService.outputDevices$ | async; track device.deviceId) {
                <option [ngValue]="device.deviceId">
                  {{ device.label }}
                </option>
              }
            </select>
          }
        </mat-form-field>
        <ng-template
          [ngTemplateOutlet]="testSound"
          [ngTemplateOutletContext]="{ $implicit: speakerDevice, type: 'Call' }"></ng-template>
      </div>

      <div class="input-settings">
        <mat-form-field
          appearance="outline"
          class="speaker-dropdown density-minus-3">
          <mat-label>{{ 'AUDIO.MICROPHONE' | translate }}</mat-label>
          @if (!displayedInPopupWindow) {
            <mat-select
              formControlName="microphoneDevice"
              (selectionChange)="disabled = false"
              [aria-label]="'Input'"
              class="device-list density-minus-3">
              @for (device of settingsService.inputDevices$ | async; track device.deviceId) {
                <mat-option [value]="device.deviceId">
                  {{ device.label }}
                </mat-option>
              }
            </mat-select>
          } @else {
            <select
              (change)="disabled = false"
              formControlName="microphoneDevice"
              matNativeControl
              required>
              @for (device of settingsService.inputDevices$ | async; track device.deviceId) {
                <option [ngValue]="device.deviceId">
                  {{ device.label }}
                </option>
              }
            </select>
          }
        </mat-form-field>
        <div class="result-div">
          <div>
            @if (isRecording === false) {
              <button
                class="test-button"
                (click)="testInputSound()"
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color"
                [matTooltip]="'AUDIO.TEST_SOUND_TOOLTIP' | translate">
                {{ 'AUDIO.TEST_SOUND' | translate }}
              </button>
            } @else {
              <button
                class="stop-test-button"
                (click)="stopInputTest()"
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color"
                [matTooltip]="'AUDIO.STOP_TEST_AND_HEAR_RECORDING_TOOLTIP' | translate">
                {{ 'AUDIO.STOP_TEST_AND_HEAR_RECORDING' | translate }}
              </button>
            }
            @if (counter > 0) {
              <p
                class="counter-time"
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color">
                {{ (isRecording ? 'AUDIO.RECORDING_TIME' : 'AUDIO.PLAYING_TIME_LEFT') | translate }} : {{ counter }} sec
              </p>
            }
          </div>
          <div class="sound-bar">
            <div class="meter">
              @for (item of [].constructor(10); track $index; let i = $index) {
                <span
                  class="dot"
                  [ngStyle]="{ 'background-color': i < currentMicrophoneVolume ? '#42a010' : '#E6E6E6' }"></span>
              }
            </div>
          </div>
        </div>
      </div>
      <div
        class="ring-calls"
        [matTooltip]="'AUDIO.NOISE_SUPPRESSION_DESCRIPTION' | translate">
        <div class="label-with-beta">
          <mat-label class="label-style">{{ 'AUDIO.NOISE_SUPPRESSION' | translate }}</mat-label>
          <span
            class="beta-tag"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
            >{{ 'AUDIO.BETA' | translate }}</span
          >
        </div>
        <mat-slide-toggle
          formControlName="noiseSuppressedEnabled"
          (change)="disabled = false"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
      </div>
      <div class="title-audio-setting">{{ 'PREF_NAV.VOICEMAIL' | translate }}</div>
      <div class="output-settings">
        <mat-form-field
          appearance="outline"
          class="speaker-dropdown density-minus-3"
          [matTooltip]="'AUDIO.SELECT_PLAYBACK_SPEAKER' | translate">
          <mat-label>{{ 'AUDIO.VOICEMAIL_PLAYBACK_SPEAKER' | translate }}</mat-label>
          @if (!displayedInPopupWindow) {
            <mat-select
              formControlName="voicemailPlaybackSpeaker"
              (selectionChange)="disabled = false"
              class="device-list density-minus-3">
              @for (device of settingsService.outputDevices$ | async; track device.deviceId) {
                <mat-option [value]="device.deviceId">
                  {{ device.label }}
                </mat-option>
              }
            </mat-select>
          } @else {
            <select
              (change)="disabled = false"
              formControlName="voicemailPlaybackSpeaker"
              matNativeControl
              required>
              @for (device of settingsService.outputDevices$ | async; track device.deviceId) {
                <option [ngValue]="device.deviceId">
                  {{ device.label }}
                </option>
              }
            </select>
          }
        </mat-form-field>
        <ng-template
          [ngTemplateOutlet]="testSound"
          [ngTemplateOutletContext]="{ $implicit: voicemailPlaybackSpeaker, type: 'Voicemail' }"></ng-template>
      </div>
    </div>
    <div class="title-audio-setting">{{ 'AUDIO.RING_BACK_VOLUME' | translate }}</div>
    <div class="volume-setting-div">
      @if (showSliders) {
        <mat-slider
          class="volume-slider"
          [max]="100"
          [min]="0"
          (change)="onChange('OutboundRingBack')"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
          <input
            matSliderThumb
            formControlName="outboundRingBackVolume" />
        </mat-slider>
      }
    </div>
  </form>
</div>
<ng-template
  #testSound
  let-device
  let-type="type">
  <div class="result-div">
    @if (settingsService.isSetSinkIdSupported && activeTest !== type) {
      <button
        class="test-button"
        (click)="testOutputDevice(device, type)"
        appBrandingColor
        [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
        styleType="color"
        [matTooltip]="'AUDIO.TEST_SOUND_TOOLTIP' | translate">
        {{ 'AUDIO.TEST_SOUND' | translate }}
      </button>
    }
    @if (activeTest === type) {
      <button
        class="stop-test-button"
        (click)="stopOutputTest()"
        appBrandingColor
        [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
        styleType="color"
        [matTooltip]="'AUDIO.STOP_TEST_TOOLTIP' | translate">
        {{ 'AUDIO.STOP_TEST' | translate }}
      </button>
    }
    <div class="sound-bar">
      <div class="meter">
        @for (item of [].constructor(10); track $index; let i = $index) {
          <span
            class="dot"
            [ngStyle]="{
              'background-color': i < currentSpeakerVolume && activeTest === type ? '#42a010' : '#E6E6E6',
            }"></span>
        }
      </div>
    </div>
    @if (!settingsService.isSetSinkIdSupported) {
      <p class="warning-support-text">
        {{ 'AUDIO.BROWSER_NOT_SUPPORTED' | translate }}
        <!-- Your browser does not support this feature, please use Chrome, Edge or Opera to be able to use it. -->
      </p>
    }
  </div>
</ng-template>
